import { render, staticRenderFns } from "./PlenarySession.vue?vue&type=template&id=93939e42&scoped=true&"
import script from "./PlenarySession.vue?vue&type=script&lang=js&"
export * from "./PlenarySession.vue?vue&type=script&lang=js&"
import style0 from "./PlenarySession.vue?vue&type=style&index=0&id=93939e42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93939e42",
  null
  
)

export default component.exports